export type IncidentLabelGroupKey =
  | "incidentType"
  | "locationType"
  | "perpetrator"
  | "relationship"
  | "gender"
  | "aliveStatus"
  | "burialSiteType"
  | "estimatedBuried"
  | "violationTag";

export type IncidentLabelFallbackMap = Record<IncidentLabelGroupKey, Record<string, string>>;

export const incidentLabelFallbacks: IncidentLabelFallbackMap = {
  incidentType: {
    torture: "Torture",
    rape: "Rape",
  },
  locationType: {
    home: "Home",
    work: "Work",
    school: "School",
    prison_detention_centre: "Prison/Detention Centre",
    other__specify_in_following_question: "Other (Specify)",
    other__specify_in_the_following_question: "Other (Specify)",
  },
  perpetrator: {
    military: "Military (Tatmadaw)",
    armed_rebel_group: "Border guard police (Nasaka)",
    rohingya_dacoits_collaborators: "Other police/paramilitary",
    arakan_rohingya_army: "State militia: Arakan Army",
    rohingya_dacoits_collaborators_1: "Buddhist extremist mobs",
    rohingya_militia__arsa: "Rohingya militia: ARSA",
    rohingya_militia__ara: "Rohingya militia: ARA",
    rohingya_militia__rso: "Rohingya militia: RSO",
    rohingya_militia__other: "Rohingya militia: Other",
    rohingya_mobs_and_dacoits: "Rohingya mobs and dacoits",
  },
  relationship: {
    parent: "Parent",
    sibling: "Sibling",
    spouse: "Spouse",
    child: "Child",
    option_9: "Relative",
    niece_nephew: "Niece/Nephew",
    cousin: "Cousin",
    aunt_uncle: "Aunt/Uncle",
    grandparent: "Grandparent",
    grandchild: "Grandchild",
    other__please_specify_in_the_f: "Other",
  },
  gender: {
    male: "Male",
    female: "Female",
  },
  aliveStatus: {
    yes: "Yes",
    no: "No",
  },
  burialSiteType: {
    primary: "Primary",
    secondary: "Secondary",
  },
  estimatedBuried: {
    "1_5_people": "1-5 people",
    "5_20_people": "5-20 people",
    "20_100_people": "20-100 people",
    "100__people": "100+ people",
  },
  violationTag: {
    discrimination_in_health: "Limited healthcare access",
    discrimination_in_education: "Limited education access",
    discrimination_in_movement: "Limited movement access",
    harassment_by_authorities: "Harassed by authorities",
    land_confiscated: "Land confiscated",
    fear_for_life: "Life threatened",
  },
};
